module.exports = __webpack_public_path__ + "img/avatar.702829e2.jpg";